export const AUTH_SESSION_INVALIDATED_EVENT = 'virtual-medic:auth-session-invalidated';

export const emitAuthSessionInvalidated = (detail = {}) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(AUTH_SESSION_INVALIDATED_EVENT, { detail }));
};
